import { useFeatureFlag } from "@/shared-utils";

/** Shared by the session summary banner and the live toast so the two never drift. */
export const CUSTOMER_DROPPED_MESSAGE = "Call disconnected on the customer's end";

/** Evaluated per expert, so the notice can be targeted or A/B tested against experts who don't see it. */
export const useIsCustomerDroppedNoticeEnabled = (): boolean =>
    useFeatureFlag("EWP-isCustomerDroppedNoticeEnabled").data === true;
